// TODO
// - look at how auth errors are managed and displayed

import React, { PureComponent, Fragment } from "react";
import { connect } from "react-redux";
import { PropTypes } from "prop-types";
import { Segment, Button, Header, Icon } from "semantic-ui-react";

import { selectCopy } from "../../state/reducers/locale/copySelector.js";

class WelcomeMessage extends PureComponent {
  static propTypes = {
    testingEnvironment: PropTypes.string,
    openHelpWidget: PropTypes.func.isRequired,
    copy: PropTypes.func.isRequired
  };

  static defaultProps = {
    copyKey: "dashboard.welcome"
  };

  // -- Handlers -- //

  termsAndConditionsRequest = () => {
    const { openHelpWidget, copy } = this.props;

    const data = {
      subject: copy(`help_widget.t_and_cs.subject`),
      description: copy(`help_widget.t_and_cs.description`)
    };

    openHelpWidget(data);
  };

  // -- RENDER -- //

  render() {
    const { testingEnvironment, copyKey, copy } = this.props;

    return (
      <Fragment>
        <Header as="h3">{copy(`${copyKey}.title`)}</Header>
        <Segment padded secondary>
          <Header as="h3">
            <Icon name="user" />
            {copy(`${copyKey}.admin.title`)}
          </Header>
          <p>{copy(`${copyKey}.admin.body`)}</p>
          {!testingEnvironment && (
            <Button
              primary
              href={`mailto:${copy(`${copyKey}.admin.email_address`)}`}
            >
              {copy(`${copyKey}.admin.email_cta`)}
            </Button>
          )}
          {testingEnvironment && (
            <Button primary onClick={this.termsAndConditionsRequest}>
              {copy(`${copyKey}.admin.email_cta`)}
            </Button>
          )}
        </Segment>
        <Segment padded secondary>
          <Header as="h3">
            <Icon name="paint brush" />
            {copy(`${copyKey}.artists.title`)}
          </Header>
          <p>{copy(`${copyKey}.artists.body`)}</p>
        </Segment>
      </Fragment>
    );
  }
}

const mapStateToProps = state => ({
  copy: selectCopy(state)
});

export default connect(mapStateToProps)(WelcomeMessage);
